import styled from 'styled-components';
import { layout, media } from '@prisjakt/ui-base';
import FilterDropdownComponent from 'src/components/filter-dropdown';

export const FilterDropdown = styled(FilterDropdownComponent)`
  ${media.mediumDown`
    margin-top: ${layout.measurements.spacing150};
  `}
`;
